import { praticaRiprendiSelector } from "common/_redux/pratica/selectors";
import { subjectGetDetails } from "common/_redux/subject/actions";
import { AppStateManager } from "common/helpers/app-state-manager.utils";
import { PathEnum } from "core/routes/path.enum";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { layoutSetSteps } from "layout/_redux/actions";
import Footer from "layout/components/footer";
import Header from "layout/components/header";
import Sidebar from "layout/components/sidebar";
import Topbar from "layout/components/topbar";
import { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { reopenShowHeaderSelector } from "./_redux/selector";
import ReopenIdentificazioneLR from "./anagrafica_lr";
import ReopenIdentificazioneTE from "./anagrafica_te";
import { ReopenSteps } from "./config";
import ReopenDocumentiAziendali from "./documenti_azienda";
import ReopenDocumentiPagamenti from "./documenti_pagamenti";
import ReopenFirma from "./firma";
import ReopenIdentificazione from "./identificazione";
import ReopenProcessoTerminato from "./processo_terminato";

const ReopenPage: React.FC = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const reopenPratica = useAppSelector(praticaRiprendiSelector);
	const showHeader = useAppSelector(reopenShowHeaderSelector);

	const isDesktop = window.innerWidth >= 992;

	const init = () => {
		dispatch(subjectGetDetails())
			.unwrap()
			.then((res) => {
				if (res) {
					const rappresentanteLegale = res?.legaleRapp;
					const subjects = res;

					let stepsToShow = AppStateManager.getReopenSteps();

					if (!stepsToShow) {
						const legaleSenzaAllegati = rappresentanteLegale?.elencoAllegati?.length == 0;

						const titolariSenzaAllegati = subjects?.elencoTitolariEffettivi?.some(
							(titolare) =>
								titolare.tipoSoggetto === "Titolare" && titolare?.elencoAllegati?.length == 0
						);

						const hasAziendaliDocument = reopenPratica?.allegatiToUpload?.some(
							(allegato) =>
								allegato.tipoDocumento &&
								[
									"TULPS_GIOCO",
									"ATTO_COSTITUTIVO",
									"VERBALE_RAPP_LEGALE",
									"ATTRIBUZIONE_PARTITA_IVA",
									"LIC_AUT",
									"CONTRATTO_UTENZA_LOCAZIONE",
								].includes(allegato.tipoDocumento)
						);

						const hasPagamentoDocument = reopenPratica?.allegatiToUpload?.some(
							(allegato) => allegato.tipoDocumento === "INT_ESTRATTO_CONTO"
						);

						stepsToShow = ReopenSteps.map((step) => {
							let _step = { ...step };

							if (
								_step.route === `/reopen/${PathEnum.reopenVerificaIdentitaLR}` &&
								!legaleSenzaAllegati
							) {
								_step.hideOnMenu = true;
							}

							if (
								_step.route === `/reopen/${PathEnum.reopenVerificaIdentitaTE}` &&
								!titolariSenzaAllegati
							) {
								_step.hideOnMenu = true;
							}

							if (
								_step.route === `/reopen/${PathEnum.reopenDocumentiAziendali}` &&
								!hasAziendaliDocument
							) {
								_step.hideOnMenu = true;
							}

							if (
								_step.route === `/reopen/${PathEnum.reopenDocumentiPagamenti}` &&
								!hasPagamentoDocument
							) {
								_step.hideOnMenu = true;
							}

							return _step;
						});

						AppStateManager.setReopenSteps(stepsToShow);

						let firstStep = stepsToShow?.find((x) => x?.hideOnMenu == false)?.route;

						if (firstStep) navigate(firstStep);
					}

					dispatch(layoutSetSteps(stepsToShow));
				}
			});
	};

	useEffect(() => {
		init();
	}, []);

	return (
		<div>
			<Sidebar />

			<div className="wrapper d-flex flex-column min-vh-100">
				<div className="body flex-grow-1 px-0">
					{!isDesktop && showHeader && <Header />}

					{!isDesktop && <Topbar />}

					<div
						className={`container-fluid body-section m-0 ${
							showHeader ? "" : "body-section-no-header"
						} px-0`}
					>
						<Routes>
							<Route
								path={`${PathEnum.reopenVerificaIdentitaLR}/*`}
								element={<ReopenIdentificazioneLR />}
							/>

							<Route
								path={PathEnum.reopenVerificaIdentitaTE}
								element={<ReopenIdentificazioneTE />}
							/>

							<Route
								path={PathEnum.reopenDocumentiAziendali}
								element={<ReopenDocumentiAziendali />}
							/>

							<Route
								path={PathEnum.reopenDocumentiPagamenti}
								element={<ReopenDocumentiPagamenti />}
							/>

							<Route path={PathEnum.reopenIdentificazione} element={<ReopenIdentificazione />} />

							<Route path={PathEnum.reopenFirma} element={<ReopenFirma />} />

							<Route
								path={PathEnum.reopenProcessoTerminato}
								element={<ReopenProcessoTerminato />}
							/>
						</Routes>
					</div>
				</div>

				<Footer />
			</div>
		</div>
	);
};

export default ReopenPage;
